import { QueryFactory } from "../../../../Common";
export const QGetPurchases = QueryFactory("GetPurchases");
//# sourceMappingURL=QGetPurchases.js.map